import { useSidePanel } from "@/components/contexts/SidePanelContext";
import { renderFileIcon } from '@/lib/document-icons';
import { useDuplicateMap } from "../bundleTreeStore";
import type { FileNode } from "../bundleTypes";
import { DuplicateDocumentWarning } from "../DuplicateDocumentWarning";
import { InsertIndicator } from "../InsertIndicator";

type ViewFileProps = {
  file: FileNode;
}

export const ViewFile = ({file}: ViewFileProps) => {
  const duplicateMap = useDuplicateMap();
  const { openDocumentPanel, isOpen, activeDocumentGuid } = useSidePanel();
  const isActive = isOpen && activeDocumentGuid === file.fileReferenceGuid;
  const otherOccurrences = duplicateMap[file.fileReferenceGuid]?.filter(e => e.fileId !== file.fileId) ?? [];

  return (
    <div className={`flex items-center gap-2 px-2 py-1.5 rounded-sm border text-sm group transition-colors ${isActive ? 'bg-blue-50 border-blue-300' : 'bg-gray-50'}`}>
      <div className="shrink-0 cursor-pointer" onClick={() => openDocumentPanel({ documentGuid: file.fileReferenceGuid })}>{renderFileIcon(`file${file.fileExtension}`, 'h-4 w-4')}</div>
      <DuplicateDocumentWarning otherOccurrences={otherOccurrences} />
      <span className="flex-1 truncate text-sm cursor-pointer hover:text-blue-600 transition-colors" onClick={() => openDocumentPanel({ documentGuid: file.fileReferenceGuid })}>{file.customName || file.fileName}</span>
      {file.isInsert && <InsertIndicator />}
      {file.pageRange && <span className="text-xs text-gray-400 shrink-0">pp. {file.pageRange}</span>}
    </div>
  );
}
